export const MAX_STACK_COUNT = 3;

export const DateFilter = [
  {
    id: 1,
    tag_name: "Today",
  },
  {
    id: 2,
    tag_name: "Yesterday",
  },
  {
    id: 3,
    tag_name: "This Week",
  },
  {
    id: 4,
    tag_name: "This Month",
  },
  {
    id: 5,
    tag_name: "This Year",
  },
];

export const getRecruitmentStatusLabel = (value) => {
  if (value === 7) {
    return "New";
  } else if (value === 8) {
    return "In Progress";
  } else {
    return "Reopen";
  }
};

export const getSuspendStatusLabel = (value) => {
  if (value === 1) {
    return "Notification pending";
  } else if (value === 2) {
    return "Notified";
  } else {
    return "--";
  }
};

export const SHORTLIST_NOTIFICATION_TEMPLATE =
  "You have been shortlisted for a role on FlexiBees! Visit the Active Projects section of your FlexiBees App for more details.";

export const SELECTED_NOTIFICATION_TEMPLATE =
  "Congratulations!!! You have been selected for the <role> role at <client name>. Great job at acing the process! We will reach out to you shortly for the contracting.";

export const REJECTED_NOTIFICATION_TEMPLATE =
  "We regret to inform you that you have not been selected for the <role> role at <client name>. However, we will come back to you with another role that matches your skills better.";
